export default "__VITE_ASSET__B1M4KS2d__"